import { useLanguage } from "@/lib/i18n";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import type { TranslatedFAQItem } from "@/hooks/useTranslatedProductContent";

interface ProductFAQProps {
  items: TranslatedFAQItem[];
}

export function ProductFAQ({ items }: ProductFAQProps) {
  const { t } = useLanguage();

  if (items.length === 0) return null;

  return (
    <section className="py-6 md:py-8" aria-label="Product FAQ">
      <h2 className="text-2xl md:text-3xl font-extrabold text-center mb-5">
        {t('product.faqTitle')}
      </h2>
      <div className="max-w-3xl mx-auto">
        <Accordion type="single" collapsible className="space-y-3">
          {items.map((item, idx) => (
            <AccordionItem
              key={idx}
              value={`product-faq-${idx}`}
              className="bg-white/80 backdrop-blur-sm rounded-2xl border border-white/50 shadow-soft px-6 data-[state=open]:shadow-md transition-shadow"
            >
              <AccordionTrigger className="text-left font-semibold text-sm md:text-base py-5 hover:no-underline">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-sm md:text-base leading-relaxed pb-5">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
